import React from 'react'
import ScheduleModalBox from '../schedules/common_components/ScheduleModalBox'

class DashboardTimelineItem extends React.Component {
  handleClick () {
    if (this.props.justLooking) {
      this.props.handleJustLookingClick(true)
    } else {
      $.getJSON(`/timeline_items/${this.props.item.timeline_id}/fetch_details`, {fetch_link: true}, (data) => {
        gon.company_variables = {...gon.company_variables, ...data.statutory_substitutions_options}
        this.setState({
          description: data.description,
          image_url: data.image_url,
          association: data.association,
          itemFiles: data.item_files
        })
        this.props.handleClick('timeline_event', this.props.item.id)
      })
    }
  }

  onTimelineCheck (data) {
    this.props.updateTimelineItems()
    this.handleItemClose()
  }

  handleItemClose () {
    this.props.handleClick('', '')
  }

  renderModalBox () {
    if (this.props.displayModal.itemId === this.props.item.id) {
      return (
        <ScheduleModalBox
          item={this.props.item}
          handleItemClose={this.handleItemClose.bind(this)}
          type='timeline'
          onTimelineCheck={this.onTimelineCheck.bind(this)}
          description={this.state.description}
          image_url={this.state.image_url}
          association={this.state.association}
          onHelpfulCheck={this.props.onHelpfulCheck}
          isLeavePlanPartner={this.props.isLeavePlanPartner}
          itemFiles={this.state.itemFiles}
        />
      )
    }
  }
  
  readMoreButton () {
    return(
      gon.employee_layout === 'unum_theme' ? 
        <a className="unum-read-more" onClick={this.handleClick.bind(this)}>Read More</a> : 
        <button className='btn btn-dark btn-bdr-rds' onClick={this.handleClick.bind(this)}>READ MORE
      </button>
    )
  }

  render () {
    return (
      <div className='col-md-4'>
        <h4 id="upcoming-task-title">
          { this.props.item.name }
        </h4>
        <p dangerouslySetInnerHTML={{__html: this.props.item.summary.slice(0, 100) + '...'}} />
        { this.readMoreButton() }        
        { this.renderModalBox() }
      </div>
    )
  }
}

export default DashboardTimelineItem
